import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginStudent } from "../../redux/student/auth/studentAuthSlice";
import toast from "react-hot-toast";

const TestAuto = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const email = params.get("email");
    const password = params.get("password");
    const assessmentId = params.get("assessmentId");
    const companyPhotoUrl = params.get("companyPhotoUrl");

    if (email && password && assessmentId && companyPhotoUrl) {
      dispatch(loginStudent({ Email: email, Password: password })).then(
        (res) => {
          if (res.meta.requestStatus === "fulfilled") {
            toast.success("Welcome! We're getting your test ready...");
            // navigate(`/student/test/${assessmentId}/start?isAdaptive=false`);

            localStorage.setItem("fromAthena", "true");
            localStorage.setItem("companyPhotoUrl", companyPhotoUrl);
            // window.open("/test/start/instruction/${assessmentId}");
            navigate(`/test/start/instruction/${assessmentId}`);
          } else {
            toast.error("Auto-login failed, please login manually.");
            navigate("/");
          }
        }
      );
    } else {
      toast.error("Missing login info");
      navigate("/");
    }
  }, []);

  return (
    <div style={{ textAlign: "center", paddingTop: "100px" }}>
      <h2>Welcome! We're getting your test ready...</h2>
    </div>
  );
};

export default TestAuto;
